module.exports = __webpack_public_path__ + "img/facebook.b40b76c6.svg";